import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
// Serialization
import { deserialize, serialize } from 'serializr';
import { workspaceSchema } from './schemas';
// Fragments
import { workspaceFragment } from './fragments';
// Custom
import { SEARCHFIELD_TYPES } from '../../constants/App';

/**
 * Serialization
 */
const deserializeWorkspace = (data) => deserialize(workspaceSchema, data);

const serializeWorkspace = ({ name }) => ({
  ...serialize(workspaceSchema, {
    ...(name && { name }),
  }),
});

/**
 * Utils
 */
const workspaceTitle = (workspace) => _get(workspace, 'name', '');

/**
 * GraphQL
 */
const queListWorkspaces = `
  query ListWorkspaces($pagination: PaginationInput, $search: ListWorkspacesSearchInput, $sort: [ListWorkspacesSortInput!]) {
    listWorkspaces(pagination: $pagination, search: $search, sort: $sort) {
      entries {
        ...workspaceFragment
      },
      pageNumber,
      pageSize,
      totalEntries,
      totalPages
    }
  }

  ${workspaceFragment}
`;

const queGetWorkspace = `
  query GetWorkspace($input: GetWorkspaceInput!) {
    getWorkspace(input: $input) {
      ...workspaceFragment
    }
  }

  ${workspaceFragment}
`;

const mutCreateWorkspace = `
  mutation CreateWorkspace($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      id
    }
  }
`;

const mutUpdateWorkspace = `
  mutation UpdateWorkspace($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      id
    }
  }
`;

/**
 * Model
 */
const workspace = {
  name: 'workspace',
  icon: 'workspace',

  // Serialization
  deserialize: deserializeWorkspace,
  serialize: serializeWorkspace,

  // Utils
  title: workspaceTitle,

  // List features
  listFeatures: {
    // Default list params
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [{ field: 'name', dir: 'desc' }],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1,
      xl: 1,
    }),
    columns: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        sortable: true,
      },
    ],

    // Search fields
    searchFields: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'name',
        },
      },
    ],
  },

  // GraphQL
  queListWorkspaces,
  queGetWorkspace,
  mutCreateWorkspace,
  mutUpdateWorkspace,
};

module.exports = workspace;



// WEBPACK FOOTER //
// ./models/cpm/workspace.js